import appConfig from '@/app-config';
import { createClient } from '@/utils/create-client';
import axios from 'axios';

const client = axios.create({
    baseURL: appConfig.api.photos,
});

export const EmpeDriveApiClient = createClient(client);
